import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-layout-horizontal-control',
  templateUrl: './layout-horizontal-control.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./layout-horizontal-control.component.scss']
})
export class LayoutHorizontalControlComponent {
}
